import { render, staticRenderFns } from "./InventoryFinancial.vue?vue&type=template&id=4fd038a4&"
import script from "./InventoryFinancial.vue?vue&type=script&lang=js&"
export * from "./InventoryFinancial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports